"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageUrl = exports.default = void 0;

var _preact = require("preact");

var _htmlParser = _interopRequireDefault(require("../utils/htmlParser"));

var _cdnImage = require("@insided/shared/utils/cdnImage");

var _classnames = _interopRequireDefault(require("classnames"));

var isAbsoluteUrl = function isAbsoluteUrl(imgUrl) {
  return imgUrl.indexOf('://') > 0;
};

var getImageUrl = function getImageUrl(img, width, attachmentCdn) {
  var isAbsoluteImgUrl = isAbsoluteUrl(img);
  var isImgUrlContainingCdn = img.includes(attachmentCdn);

  if (isAbsoluteImgUrl && !isImgUrlContainingCdn) {
    return img;
  }

  var absoluteSrc = isImgUrlContainingCdn ? img : attachmentCdn + img;
  return (0, _cdnImage.buildResizedCdnUrl)(absoluteSrc, {
    width: parseInt(width, 10)
  });
};

exports.getImageUrl = getImageUrl;

var TopicContent = function TopicContent(_ref) {
  var _ref2, _relevantPost$content, _relevantPost;

  var topic = _ref.topic;
  var content = (_ref2 = (_relevantPost$content = topic === null || topic === void 0 ? void 0 : (_relevantPost = topic.relevantPost) === null || _relevantPost === void 0 ? void 0 : _relevantPost.content) !== null && _relevantPost$content !== void 0 ? _relevantPost$content : topic === null || topic === void 0 ? void 0 : topic.content) !== null && _ref2 !== void 0 ? _ref2 : '';

  var trimmedContent = _htmlParser.default.stripHtml(content.trim()).substr(0, 1000);

  return topic.featuredImage ? (0, _preact.h)("div", {
    className: "thread-list-block__article-wrapper"
  }, (0, _preact.h)("div", {
    className: "thread-list-block__article-excerpt"
  }, (0, _preact.h)("p", {
    className: (0, _classnames.default)('thread-list-block__content', {
      'thread-list-block__content--article': topic.featuredImage
    }, 'qa-topic-content')
  }, (0, _preact.h)("span", null, trimmedContent)))) : (0, _preact.h)("p", {
    className: "thread-list-block__content qa-topic-content"
  }, (0, _preact.h)("span", null, trimmedContent));
};

var _default = TopicContent;
exports.default = _default;